export const RADIO_1 = '15';
export const RADIO_2 = '30';
export const RADIO_3 = '60';
